import { render, staticRenderFns } from "./EditParentDialog.vue?vue&type=template&id=04649c34&scoped=true&"
import script from "./EditParentDialog.vue?vue&type=script&lang=js&"
export * from "./EditParentDialog.vue?vue&type=script&lang=js&"
import style0 from "./EditParentDialog.vue?vue&type=style&index=0&id=04649c34&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04649c34",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VForm,VSkeletonLoader})
